import { render, staticRenderFns } from "./SectionCourse.vue?vue&type=template&id=32352332&"
import script from "./SectionCourse.vue?vue&type=script&lang=js&"
export * from "./SectionCourse.vue?vue&type=script&lang=js&"
import style0 from "./SectionCourse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports